










import { Vue, Prop, Component ,Inject } from 'vue-property-decorator'
import { getSelectedCityId } from '@utils/index'

@Component
export default class SearchInput extends Vue {

  search(){
    this.$router.push({ name: 'search' })
  }
}
